var hoverSelector = ':hover:not([disabled]):not([data-disabled])';
var activeSelector = ':active:not([disabled]):not([data-disabled])';
var disabledSelector = '&[disabled]:not([data-loading]), &[data-disabled]:not([data-loading])';

export { activeSelector as a, disabledSelector as d, hoverSelector as h };
